export const Options = {
    body: {
        name: ['#ms.required', '#ms.length|max:20'],
        desc: ['#ms.length|max:50'],
        type: ['#ms.required']
    }
};
